  $(document).on('ready', function() {
    $('#slick_{{ section.id }}').slick({
      slidesToShow: 4,
       dots: true,
      slidesToScroll: 1,
      nextArrow: '<button type="button" class="brands-slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
      prevArrow: '<button type="button" class="brands-slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 4, slidesToScroll: 1 } },
        { breakpoint: 768, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        { breakpoint: 700, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        { breakpoint: 500, settings: { slidesToShow: 1, slidesToScroll: 1 } }
      ]
    });
  })